import comData from "./comData.js"
import commonData from "../view/common/commonData.js"
import chatData from "../view/chat/chatData.js"
import Notice from "../view/common/notice.js"
import ChatTerm from "../view/chat/ChatTerm.js"
import m from "mithril"
import Box from "../view/common/box.js"
import Tag from "../view/common/tag.js"
import settingData from "../view/setting/settingData.js"
import format from "../view/common/format.js"
import { trs } from "../view/common/i18n.js"
import getColor from "../view/common/getColor.js"

export default {
  socket: null,
  isInit: false,

  init() {
    if (this.isInit) {
      return
    }
    this.socket = io()

    this.socket.on("connect", () => {
      console.log("连接成功")
    })

    this.socket.on("sys:updateStatus", (status) => {
      // console.log("Update Status:", status)
      commonData.updateStatus = status
      m.redraw()

      if (['up-to-date', 'error', 'downloaded'].includes(status.state)) {
        setTimeout(() => {
          commonData.updateStatus = { state: "idle", progress: 0, msg: "" }
          m.redraw()
        }, 5000)
      }
    })

    this.socket.on("comData", async (data, callback) => {
      try {
        if (data.version > comData.data.get().version) {
          comData.data.setData(data)
          m.redraw()
          callback({
            ok: true,
            msg: `客户端收到comData，更新成功，收到数据见data
服务端版本${data.version}
客户端版本${comData.data.get().version}
`,
            data: data
          })
        }
        else {
          let tmp = await m.request({
            url: `/api/comData/get`
          })
          comData.data.setData(tmp.data)
          callback({
            ok: false,
            msg: `服务端推送版本小于当前客户端版本，收到数据见data
服务端版本${data.version}
客户端版本${comData.data.get().version}
拉取并更新服务端最新版本..
              `,
            data: data

          })
        }
      }
      catch (err) {
        console.log(err)
        throw err
      }

    })

    this.socket.on("chat", async (msg) => {
      //console.log("客户端收到chat消息", msg)
      if (msg.tid) {
        // 在所有队列中寻找对应的终端消息
        let chat = null
        const chatLists = comData.data.get().chatLists
        if (chatLists) {
          for (const list of chatLists) {
            chat = list.data.find(item => item.tid === msg.tid)
            if (chat) break
          }
        }

        if (chat) {
          chat.content += msg.content
          chat.chunk = msg.content


          if (chatData.xTerms[chat.tid]) {
            chatData.xTerms[chat.tid].forEach((term) => {
              term.write(msg.content)
            })
          }

          //chatData.currentTalk = chat
          // 检查是否正在回复中，如果是则不自动标记回复终端
          if (!comData.data.get().replying) {
            if (comData.data.get().sendMode === "terminal") {
              await comData.data.edit((data) => { data.call = { ...chat } })
            }
          }
        }
        else {
          chatData.list.push(msg)
        }
      }
      else {
        chatData.list.push(msg)
      }
      if (msg.group !== "user") {
        chatData.preparing = false
      }

      //滚动到底部

      let dom = document.querySelector(`#chatList_${msg.chatListId || 0}`)
      if (dom) {
        setTimeout(() => {

          if (!msg.tid) {
            dom.scrollTo({
              left: 0,
              top: dom.scrollHeight,
              behavior: "smooth",
            })
          }

        }, 200)
      }

      m.redraw()
    })

    this.socket.on("notice", async (msg) => {
      Notice.launch({
        msg: msg
      })
    })


    this.socket.on("project:state", async (msg) => {
      commonData.currentProject = msg.path || ""
      if (msg.autoSave !== undefined) {
        commonData.autoSaveEnabled = msg.autoSave
      }
      m.redraw()
    })


    this.socket.on("openTerminal", async (msg) => {
      await comData.data.edit(data => {
        data.currentTid = msg.currentTid
      })
      let currentTid = comData.data.get().currentTid
      let currentChat = null
      const chatLists = comData.data.get().chatLists
      if (chatLists) {
        for (const list of chatLists) {
          currentChat = list.data.find(chat => chat.tid === currentTid)
          if (currentChat) break
        }
      }

      if (currentChat) {
        Notice.launch({
          sign: currentChat.tid,
          tip: "终端" + currentTid,
          content: ChatTerm,
          contentAttrs: {
            chat: currentChat
          },
          show: false,
        })

      }

    })


    // App 事件监听
    this.socket.on("app:error", (msg) => {
      Notice.launch({
        msg: `[App 错误] ${msg.msg}`,
        type: "error"
      })
    })


    this.socket.on("app:launch", async (msg) => {
      try {
        const module = await import(msg.frontendUrl)
        let component = module.default
        if (typeof component === "function") {
          // 参数注入模式
          component = component({ appId: msg.appId, m, Notice, ioSocket: this, comData, commonData, chatData, settingData, format, Box, Tag, iconPark: window.iconPark, getColor, trs })
        }
        // Window Management: Resolve Geometry
        const saved = msg.data && msg.data.window
        const def = msg.window || {}

        let targetW = (saved && saved.width) || def.width || 0
        let targetH = (saved && saved.height) || def.height || 0

        // Safe capping for defaults
        if (!saved && targetW) targetW = Math.min(targetW, window.innerWidth * 0.95)
        if (!saved && targetH) targetH = Math.min(targetH, window.innerHeight * 0.95)

        let targetX = (saved && saved.x !== undefined) ? saved.x : 0
        let targetY = (saved && saved.y !== undefined) ? saved.y : 0

        // Auto-center if not saved but has specific size
        if ((!saved || saved.x === undefined) && targetW > 0 && targetH > 0) {
          targetX = (window.innerWidth - targetW) / 2
          targetY = (window.innerHeight - targetH) / 2
        }

        // Mark as launched in backend
        settingData.fnCall("appGuiLaunched", [msg.appId]).catch(e => console.warn("Failed to mark app active", e))

        // 定义窗口配置对象
        const noticeObj = {
          sign: msg.appId,
          group: msg.type,
          tip: (msg.icon || "📦") + " " + msg.name,
          headerButtons: [
            {
              icon: window.iconPark ? window.iconPark.getIcon("Quote", { fill: "#eee", size: "12px" }) : '"',
              color: "#5e6c79",
              onclick: () => {
                chatData.quoteAppId(msg.appId)
                // 点击引用后，自动将弹窗最小化
                if (noticeObj._winConfig && noticeObj._winConfig.id) {
                  Notice.minimizeWindow(noticeObj._winConfig.id)
                }
              }
            }
          ],
          width: targetW,
          height: targetH,
          x: targetX,
          y: targetY,
          minimized: saved ? saved.minimized : false,
          win: saved ? { x: saved.x, y: saved.y, width: saved.width, height: saved.height } : undefined,
          onWindowUpdate: (rect) => {
            // Sync window state to backend
            settingData.fnCall("appUpdateWindow", [msg.appId, rect])
          },
          cancel: async (dom, closeNative) => {
            // 集中处理 App 关闭逻辑：通知后端销毁
            await settingData.fnCall("appClose", [msg.appId])
            closeNative()
          },
          content: component,
          contentAttrs: {
            appId: msg.appId,
            data: msg.data
          }
        }

        Notice.launch(noticeObj)
      } catch (e) {
        console.log("app加载失败:", e)
        Notice.launch({
          msg: `app加载失败: ${e.message}`,
          timeout: 5000,
          color: "red"
        })
      }
    })

    this.socket.on("app:close", async (msg) => {
      // 遍历所有窗口和标签页，关闭匹配的 App
      const dataArr = Notice.data.dataArr
      if (dataArr) {
        for (let i = dataArr.length - 1; i >= 0; i--) {
          const tab = dataArr[i]
          const isMatch = (tab.sign == msg.appId) ||
            (tab.contentAttrs && tab.contentAttrs.appId == msg.appId) ||
            (typeof tab.sign === 'string' && tab.sign.startsWith(msg.appId + "_"))

          if (isMatch) {
            Notice.closeTab(tab)
          }
        }
      }
      m.redraw()
    })

    this.socket.on("app:active", async (msg) => {
      const { appId } = msg
      const dataArr = Notice.data.dataArr
      if (dataArr) {
        const tab = dataArr.find(t =>
          (t.sign === appId) ||
          (t.contentAttrs && t.contentAttrs.appId === appId) ||
          (typeof t.sign === 'string' && t.sign.startsWith(appId + "_"))
        )
        if (tab && tab._winConfig) {
          Notice.activateWindow(tab._winConfig.id)
          // 如果该窗口是多标签，还需要确保当前标签被选中
          tab._winConfig.activeSign = tab.sign
          m.redraw()
        }
      }
    })

    // === App 最小化指令 (Back-to-Front) ===
    // 此监听器处理由后端主动发起的最小化请求（例如：浏览器截图工具在抓取完成后要求恢复隐藏）。
    //
    // 【系统设计原则：状态闭环同步】
    // 1. 常规模式 (Front-to-Back): 用户点击前端窗口上的最小化按钮 -> 触发并执行 Notice.minimizeWindow()
    //    -> 修改前端内存 state -> 触发 handleWindowUpdate 钩子 ->
    //    通过 settingData.fnCall("appUpdateWindow") 将最新坐标/最小化状态同步回执给后端存储。
    //
    // 2. 指令模式 (Back-to-Front): 后端通过 Socket 发出 "app:minimize" -> 前端在此接收指令 ->
    //    调用 Notice.minimizeWindow() -> 进而驱动执行上述【常规模式】的所有逻辑（视觉隐藏 + 再次状态回执）。
    //
    // 这种设计确保了无论是谁发起的动作，最终的“窗口最小化状态”在物理表现和前后端数据镜像中都能保持严格一致。
    this.socket.on("app:minimize", async (msg) => {
      const { appId } = msg
      const dataArr = Notice.data.dataArr
      if (dataArr) {
        const tab = dataArr.find(t =>
          (t.sign === appId) ||
          (t.contentAttrs && t.contentAttrs.appId === appId) ||
          (typeof t.sign === 'string' && t.sign.startsWith(appId + "_"))
        )
        if (tab && tab._winConfig) {
          // 借用 Notice 模块已有的成熟逻辑，它会自动触发 handleWindowUpdate 从而完成对后端的确认回执
          Notice.minimizeWindow(tab._winConfig.id)
          m.redraw()
        }
      }
    })

    this.socket.on("app:dispatch", async (msg, callback) => {
      // Use commonData registry
      const data = commonData.appsData[msg.appId]

      if (data) {
        if (data.onDispatch) {
          data.onDispatch(msg, callback)
        } else {
          if (typeof callback === 'function') callback({ ok: false, msg: "App 数据实例缺少 onDispatch 方法" })
        }
      } else {
        if (typeof callback === 'function') callback({ ok: false, msg: "未找到运行中的 App 实例" })
      }
    })

    // 子智能体窗口自动弹出
    this.socket.on("agentWindow:open", async (msg) => {
      try {
        const AgentWindow = (await import("../view/chat/AgentWindow.js")).default
        const { listId, name } = msg
        Notice.launch({
          sign: "agent_" + listId,
          tip: "🤖 " + (name || trs("智能体窗口/标题", { cn: `智能体 ${listId}`, en: `Agent ${listId}` })),
          content: AgentWindow({ listId, agentName: name }),
          width: 600,
          height: 800,
        })
      } catch (e) {
        console.error("子智能体窗口弹出失败:", e)
      }
    })

    this.isInit = true

  }
}